import {
  type ConfirmAttendanceRequest,
  confirmAttendanceRequestSchema,
  confirmAttendanceResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useMutation } from "@tanstack/react-query";

export function getConfirmAttendanceUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/workers/:workerId/attendance-confirmations`.replace(
    ":workerId",
    workerId
  );
}

export function useConfirmAttendance() {
  const worker = useDefinedWorker();

  return useMutation({
    mutationFn: async (data: ConfirmAttendanceRequest) => {
      const response = await post({
        url: getConfirmAttendanceUrl(worker.userId),
        data,
        requestSchema: confirmAttendanceRequestSchema,
        responseSchema: confirmAttendanceResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.POST_CONFIRM_ATTENDANCE_FAILURE,
    },
  });
}
